// src/test/TestForm.jsx
// import ReadOnlyEditor from "../components/tiptap-templates/simple/read-only-editor";
import SimpleTiptapEditor from "../components/tiptap-templates/simple/custom-editor";
// import TiptapEditor from "../components/tiptap-templates/simple/simple-editor";

function TestForm() {
  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100 ">
      <div className="row w-100">       
          <SimpleTiptapEditor/>
      </div>
    </div>
  );
}

export default TestForm;